export enum SaveStatus {
    None,
    Pending,
    Success,
    Error
}